import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import DatePicker from "react-datepicker";
import {useRecoilState} from "recoil";
import Config from "../../core/config";

import SupplierSelect from "../supplier/SupplierSelect";
import {getSupplierById} from "../../utils/requestUtils";
import SearchButton from "../../core/SearchButton";
import BackButton from "../common/BackButton";
import ConfirmButton from "../common/ConfirmButton";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import DecimalInput from "../common/DecimalInput";
import Cookies from "js-cookie";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";
import Loading from "../../core/Loading";
import {formatDateTimeToString, formatLocalDate, UserPermission} from "../../utils/utils";
import {usePermission} from "../../core/PermissionContext";
import {handleSimpleDateChange} from "../../utils/stateInputUtils";
import {parseLocalDate} from "../../utils/utils";

const apiUrl = Config.apiUrl;

const PaymentManager = () => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');
    const [showSupplierSelect, setShowSupplierSelect] = useState(false);
    const [repeatValue, setRepeatValue] = useState(1);
    const [repeat, setRepeat] = useState(false);

    const newEntity = {
        id: undefined,
        supplier: undefined,
        description: '',
        value: 0.0,
        date: new Date().toISOString(),
        dueDate: parseLocalDate(new Date()),
        paymentDate: undefined,
        status: 0,
    };
    const [formData, setFormData] = useState(newEntity);

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleRepeatValueChange = (e) => {
        const {value} = e.target;
        if (value <= 0 || value > 12) {
            return;
        }
        setRepeatValue(value);
    };

    const handleRepeatChange = (e) => {
        const {checked} = e.target;
        setRepeat(checked);
        setRepeatValue(!checked ? 1 : 2);
    };

    const handleBirthDateChange = (date) => {
        setFormData((prevData) => ({
            ...prevData,
            ['birthDate']: date
        }));
    };

    const handleKidBirthDateChange = (date) => {
        setFormData((prevData) => ({
            ...prevData,
            ['kidBirthDate']: date
        }));
    };

    async function makeQuery() {
        if (id) {
            try {
                setLoading(true);
                const url = apiUrl + '/api/payments/id=' + id;
                const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
                setFormData(response);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        } else {
            setFormData(newEntity);
        }
    }

    useEffect(() => {
        makeQuery();
    }, [id]);

    function clearEntity() {
        setFormData(newEntity);
    }

    const onConfirm = async () => {
        try {
            if (validateInputs()) {
                setLoading(true);
                await new Promise(resolve => setTimeout(resolve, 300));
                console.log('formData', formData);
                if(id) {
                    formData.id = id;
                    await saveEntity(formData);
                } else {
                    const initialDueDate = parseLocalDate(formData.dueDate);
                    for (let i = 0; i < repeatValue; i++) {
                        let currentDueDate = new Date(initialDueDate.getTime());
                        currentDueDate.setMonth(currentDueDate.getMonth() + i);
                        formData.dueDate = formatLocalDate(currentDueDate);
                        await saveEntity(formData);
                    }
                }
                navigate('/app/paymentlist');
            }
        } catch (error) {
            console.error('Error saving:', error);
            alert('Error ao salvar.');
        } finally {
            setLoading(false);
        }
    };

    function validateInputs() {
        if (!formData.supplier) {
            alert('Preencha o campo fornecedor.');
            return false;
        }

        if (!formData.description || formData.description === '') {
            alert('Preencha o campo descrição.');
            return false;
        }

        if (!formData.value || formData.value === 0) {
            alert('Preencha o campo valor.');
            return false;
        }

        if (!formData.date || formData.date === '') {
            alert('Preencha o campo data.');
            return false;
        }

        if (!formData.dueDate || formData.dueDate === '') {
            alert('Preencha o campo data de vencimento.');
            return false;
        }

        return true;
    }

    async function saveEntity(entity) {
        const url = apiUrl + '/api/payments';
        await makeRequest(url, entity.id ? 'PUT' : 'POST', {
            'Content-Type': 'application/json',
            'Useruuid': Cookies.get('userUUID')
        }, JSON.stringify(entity));
    }

    async function selectSupplier(id) {
        const customer = await getSupplierById(id);
        setFormData((prevData) => ({
            ...prevData,
            supplier: customer
        }));
    }

    const handleSupplierItemClick = async (id) => {
        await selectSupplier(id);
        closeSupplierSelect();
    };

    function handleOnClickSupplier() {
        openSupplierSelect();
    }

    const openSupplierSelect = () => {
        setShowSupplierSelect(true);
    };

    const closeSupplierSelect = () => {
        setShowSupplierSelect(false);
    };

    // Date change handlers using the new utility function
    const handleDateChange = (date) => handleSimpleDateChange(date, 'date', setFormData);
    const handleDueDateChange = (date) => handleSimpleDateChange(date, 'dueDate', setFormData);
    const handlePaymentDateChange = (date) => handleSimpleDateChange(date, 'paymentDate', setFormData);

    if (loadingPermissions) {
        return <Loading></Loading>;
    }
    if (hasUserPermission(UserPermission.CREATE_PAYMENT) === false || (hasUserPermission(UserPermission.EDIT_PAYMENT) === false && id)) {
        navigate('/unauthorizedaccess');
        return null;
    }

    return (
        <div>
            {showSupplierSelect && (
                <SupplierSelect onItemClick={handleSupplierItemClick} onClose={closeSupplierSelect}/>)}
            <div className="header-label">{formData.id > 0 ? 'Editar' : 'Cadastrar'} Pagamento</div>

            {formData.id && (
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Código:</div>
                    <input type="text" style={{backgroundColor: '#CCCCCC'}} value={formData.id} disabled={true}/>
                </div>)}

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Fornecedor:</div>
                <SearchButton onClick={handleOnClickSupplier}/>
                <input type="text" disabled={true} value={formData.supplier ? formData.supplier.name : ''}
                       style={{flexGrow: 1}}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Descrição:</div>
                <input type="text" style={{width: '300px'}} value={formData.description} name="description"
                       onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Valor:</div>
                <DecimalInput
                    style={{width: '100px'}}
                    placeholder="0,00"
                    value={formData.value}
                    name="value"
                    onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Data de Lançamento:</div>
                <input
                    disabled
                    type="text"
                    style={{width: '130px'}}
                    value={formatDateTimeToString(new Date(formData.date))}
                />
            </div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Data de Vencimento:</div>
                <DatePicker
                    className="datepicker"
                    dateFormat="dd/MM/yyyy"
                    selected={formData.dueDate ? parseLocalDate(formData.dueDate) : null}
                    onChange={handleDueDateChange}
                    isClearable
                    autoComplete="off"
                />
            </div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Data de Pagamento:</div>
                <DatePicker
                    className="datepicker"
                    dateFormat="dd/MM/yyyy"
                    selected={formData.paymentDate ? parseLocalDate(formData.paymentDate) : null}
                    onChange={handlePaymentDateChange}
                    isClearable
                    autoComplete="off"
                />
            </div>

            {!id &&
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <input type="checkbox" checked={repeat}
                           onChange={handleRepeatChange}/>
                    <div>Repetir?</div>
                </div>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <input type="number"
                           style={{width: '100px'}}
                           disabled={!repeat}
                           min={2}
                           max={12}
                           step="1" placeholder="0"
                           value={repeatValue}
                           onChange={handleRepeatValueChange}/>
                    <div> (meses)</div>
                </div>
            </div>
            }

            <ActionButtonsManagerView>
                <BackButton />
                <ConfirmButton onClick={onConfirm}/>
            </ActionButtonsManagerView>
        </div>
    );
};

export default PaymentManager;
